import { useState, useEffect } from 'react';

// Apply saved theme immediately on module load to prevent flash
const _saved = localStorage.getItem('larynx_theme') || 'light';
// Coerce legacy values: 'dark' → 'indigo', 'zoho' → 'light'
const _initial = _saved === 'dark' ? 'indigo' : _saved === 'zoho' ? 'light' : _saved;
document.documentElement.setAttribute('data-theme', _initial);

export default function useTheme() {
  const [theme, setTheme] = useState(_initial);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('larynx_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'light' ? 'indigo' : 'light');

  return { theme, toggleTheme };
}
